export default () => {

    return `
    
    <div class="container totop__container">
        <div class="row">
            <div class="col text-center">
                <a href="#totop" class="totop__link">
                    <span class="material-icons-outlined totop__icon">arrow_upward</span>
                    <span class="totop__text">Til toppen</span>
                </a>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="container footer__container ">
            <div class="row justify-content-center text-center text-sm-left" >
                <div class="col-sm-10">
                    <div class="row">
                        <div class="col-sm-6"><a href="/" class="footer__logolink"><img src="/dist/images/logo-kongsberghistoriefortelling.svg" alt="" class="footer__logoimg"></a></div>
                        <div class="col-sm-6 text-sm-right">
                            <a href="/annet/20139a0c-3c50-49b8-80f1-c659c43eae96" class="footer__link">Kontaktopplysninger</a>
                            <a href="/annet/9a5f6389-0fb2-4d8c-85c0-034bd8c2e96f" class="footer__link">Personvernerklæring</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    `

}
